import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <section
      data-testid="notfound-page"
      className="min-h-[70vh] flex items-center justify-center bg-brand-ivory px-6"
    >
      <div className="text-center max-w-xl">
        <p className="eyebrow text-brand-gold">Page not found</p>
        <h1 className="mt-6 font-heading text-5xl md:text-6xl text-brand-ink leading-tight">
          We lost our way.
        </h1>
        <p className="mt-6 text-brand-ink/70 leading-relaxed font-light">
          The page you're looking for doesn't exist — or has moved. Let's get you back home.
        </p>
        <Link
          to="/"
          data-testid="notfound-home-btn"
          className="mt-10 inline-flex items-center gap-2 px-8 py-4 bg-brand-forest text-white text-[12px] uppercase tracking-[0.22em] font-semibold rounded-sm hover:bg-brand-forestDark transition-colors"
        >
          <ArrowLeft size={16} /> Back to Home
        </Link>
      </div>
    </section>
  );
}
